import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import $ from 'jquery';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';

const GLOBAL = require('../../Globals');

class Daybook extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			vno : '',
			vdate : moment(),
			vtype : '',
			vcmas : '',
			vhead : '',
			accgrp : '',
			transno : '',
			tdate : '',
			reference : '',
			cheno : '',
			cdate : '',
			bankname : '',
			paidto : '',
			mobile : '',
			amt : '',
			narration : '',
			_message : '',
			alertClass :'',
			id : '',
			_redirect : false,
			posts: [],
			master : [],
			acgrp : []
		}
		this.handleChange = this.handleChange.bind(this);
		this.printDocument = this.printDocument.bind(this);
		this.onBack = this.onBack.bind(this);
	}
	
	printDocument() {
	
		var mywindow = window.open('', 'PRINT', 'height=400,width=600');

		mywindow.document.write('<html><head><title>' + document.title  + '</title>');
		mywindow.document.write('</head><body >');
		mywindow.document.write('<h1>' + document.title  + '</h1>');
		mywindow.document.write('<table border="1">');
		mywindow.document.body.innerHTML = document.getElementById("printableTable").innerHTML
		mywindow.document.write('</table>');
		mywindow.document.write('</body></html>');
		mywindow.print();
		mywindow.close();

	 }
	 
	/* redirect to voucher List */
	onBack(e){
		
		this.setState({_redirect : true});
	}
	
	/** set value to voucher datepicker **/
	handleChange(e) {
		this.setState({[e.target.name]:e.target.value});
	}
	
	/** this function will be call when page loading **/
	componentDidMount() {
		 
		
	}
	 
	
  render() {
	
	$("#ckdate").change(function(){
		var sr = $(this).val();
		$.get(GLOBAL.BASE_URL+'accounts/getvoucherbydate/'+'/'+sr,function(o){
			
			$("#day").html('');
			$('#day')
			$.each(o,function(key,value){			
				$('#day')
					.append('<tr><td>'+value.vno+'</td><td>'+value.vdate+'</td><td>'+value.accountname+'</td><td>'+value.voucherhead+'</td><td>'+value.vouchermaster+'</td><td>'+value.narration+' - '+value.paidto+'</td><td>&#x20a8;&nbsp;'+value.amount+'</td></tr>');
			});
		},'json');
		
	});
	
	var tableStyle = {
       "border": "1px solid black",
	   "padding": "15px"
    };
	
    return (
		<div className="animated fadeIn">
			<div className={this.state.alertClass}>
				{this.state._message}
			</div>
			<Row>
			  <Col md="12">
				<Card>
				  <CardHeader>
					<strong>Day book</strong>
				  </CardHeader>
				  <CardBody>
					<Row>
					  <Col md="12">
						<Row>
							<Col md="3">
							  <FormGroup>
								<Input type="date" onChange={this.handleChange} className="form-control" id="ckdate" />
							  </FormGroup>
							</Col>
							<Col md="3">
							  <FormGroup>
								<Button size="sm" color="primary" onClick={this.printDocument}><i className="fa fa-print"></i> Print </Button>
							  </FormGroup>
							</Col>
						</Row>
						<table className="table table-bordered" id="printableTable">
							<thead>
								<tr>
									<th>Voucher No</th>
									<th>Date</th>
									<th>Account Group</th>
									<th>Voucher Head</th>
									<th>Voucher Master</th>
									<th>Narration</th>
									<th>Amount</th>
								</tr>
							</thead>
							<tbody id="day">
								
							</tbody>
						</table>
					  </Col>
					</Row>
				  </CardBody>
				</Card>
			  </Col>
			</Row>
		</div>
	)
  }
}

export default Daybook;


// WEBPACK FOOTER //
// ./src/accounts/Daybook/Daybook.js